"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEOToJSON = exports.SEOFromJSONTyped = exports.SEOFromJSON = void 0;
function SEOFromJSON(json) {
    return SEOFromJSONTyped(json, false);
}
exports.SEOFromJSON = SEOFromJSON;
function SEOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'url': json['url'],
        'tags': json['tags'],
    };
}
exports.SEOFromJSONTyped = SEOFromJSONTyped;
function SEOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'url': value.url,
        'tags': value.tags,
    };
}
exports.SEOToJSON = SEOToJSON;
